export default "/_next/static/images/16d65e46a2e8702dcc794e78e746ecd7.png";